import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./three-col-seven-stories.m.css";

export const OtherStory = ({ story, showSeparator, defaultFallback, showTimestamp, showReadTime, sectionSlug }) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  const showImageThumbnail = isPartneredContent || defaultFallback;
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName="common-story" style={{ border: `${showSeparator || "none"}` }}>
      <Link href={href} target={target}>
        <div styleName="second-card">
          {showImageThumbnail && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[4, 3]]}
                iconSizes={{ height: 24, width: 24 }}
                defaultFallback={true}
              />
            </div>
          )}
          <div styleName="right-column">
            {label && <Label story={story} />}

            {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}
            <PublishAndReadTime story={story} showTimestamp={showTimestamp} showReadTime={showReadTime} />
          </div>
        </div>
      </Link>
    </div>
  );
};

OtherStory.propTypes = {
  story: object,
  showSeparator: bool,
  defaultFallback: bool,
  showTimestamp: bool,
  showReadTime: bool,
  sectionSlug: string,
};
